import { render, staticRenderFns } from "./KbmStep.vue?vue&type=template&id=77350303&scoped=true&"
import script from "./KbmStep.vue?vue&type=script&lang=js&"
export * from "./KbmStep.vue?vue&type=script&lang=js&"
import style0 from "./KbmStep.vue?vue&type=style&index=0&id=77350303&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77350303",
  null
  
)

export default component.exports